import React from 'react';
import ViewProfile from './viewProfile';
import EditProfile from './editProfile';

const Main = props => {
  return (
    <section
      className="container-main-principal flex"
    >
	    <ViewProfile
	      datos={props.datos}
	      language={props.language}
	      filter={props.filter}
	    />
	    <EditProfile
	      datos={props.datos}
	      language={props.language}
	      handleModalPass={props.handleModalPass}
          handleClickConnectFitbit={props.handleClickConnectFitbit}
	      handleClickDisconnectFitbit={props.handleClickDisconnectFitbit}
		  handleClickResetTours={props.handleClickResetTours}
	    />		
    </section>
  );
};
export default Main;



// WEBPACK FOOTER //
// ./source/client/components/user_profile/main.jsx